import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
  selector: 'panelm-loading-initial-data',
  templateUrl: './loading-initial-data.component.html',
  styles: [`
    ::ng-deep.cdk-overlay-dark-backdrop {
      background: rgba(0,0,0,.1) !important;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoadingInitialDataComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
